import { useState, useEffect } from 'react';
import axios from 'axios';
import YouInvest from 'src/Api/YouInvest';
import { MegaNav } from "@ajbellbusinessolution/web-components";
import * as Sentry from '@sentry/nextjs';
import menuDataHardcoded from './MenuDataHardcoded';

export default function HeaderRebrandedNew({ headerData, breadcrumb, topOfPageConfig }) {

	

	  
	//const [accountData, setAccountData] = useState(null);

	// useEffect(() => {
	// 	if (accountData === null) {
	// 		getAccountData();
	// 	}
	// }, [accountData]);

	// const getAccountData = () => {
	// 	axios({
	// 		method: 'GET',
	// 		url: `/api/account/account-summary`,
	// 		headers: YouInvest.getTradingRequestHeaders()
	// 	}).then((response) => {
	// 		setAccountData({ userData: response.data.data.accounts, navigation: HardcodedPlaceholders.signedInNavigation });
	// 	}).catch((e) => {
	// 		Sentry.captureException(e);
	// 	})
	// }

	return <>
		<div className="admin-menu will-change ajb-grid-row red-500-bg padding-right-0 padding-left-20 padding-left-0-sm" style={{zIndex: '100'}}>
			{/* Breadcrumb */}
			<div className="float-left padding-10 admin-menu--breadcrumb breadcrumb-trigger hide-sm">
				<nav className="nav-wrapper-breadcrumb nav-wrapper-breadcrumb-alt border-none">
					<div className="nav-wrapper">
						<a className="breadcrumb-alt" href="/" title="Home"><i className="fa fa-map-marker margin-right-5" aria-hidden="true"></i>Home</a>
						<span className="breadcrumb-alt">Market research</span>
						<span className="breadcrumb-alt font-weight-bold truncate">{breadcrumb}</span>
					</div>
				</nav>
			</div>
			<div className="float-right text-align-right admin-menu--links float-none-sm ajb-col-8-breakpoint">

                    <div className="h7 margin-0 padding-right-10">
                      
						<span>
							{
		
                                topOfPageConfig ? topOfPageConfig.map((item, index) => {
									
                                    try { 
                                        let extraCssClass = item.link.localized_options.item_attributes.class === 'external' ? 'external' : '';
                                        let target = (!Array.isArray(item.link.localized_options.attributes) && item.link.localized_options.attributes.target === '_blank') ? '_blank' : '';
                                        return <a target={target} key={index} className={`margin-right-0 white-text padding-top-10 padding-right-10 padding-bottom-10 padding-left-0 inline-block ${extraCssClass}`} href={item.link.link_path}>
                                            {item.link.link_title}
                                        </a>
                                    } catch (e) {}
                                }) : null
                            }
						</span>

                    </div>
                </div>
		</div>
		
		<div>
			<MegaNav menuData={menuDataHardcoded}/>
		</div>
	</>
}
